import {DEBUG} from "./config"

export const print = (...args) => DEBUG && console.log.apply(null, args);
